import '@/context';
import 'zone.js';

import React from 'react';
import { EnvironmentName } from '@hpfe/common-base';
// import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import { App } from './app';
import { context } from '@/context';

const environmentName = context.config.environmentName;

if (environmentName === EnvironmentName.release) {
  // 先暂时注释，等有了sentry的配置再打开
  // Sentry.init({
  //   environment: environmentName,
  //   release: `f2e-delivery-allocation`,
  //   dsn: 'https://6aabf2bd930f76184c6bffc5dce5516b@sentry.hungrypanda.it/8',
  //   // 错误重播采样率
  //   replaysOnErrorSampleRate: 1.0,
  //   integrations: [
  //     Sentry.browserTracingIntegration(),
  //     Sentry.replayIntegration(),
  //   ],
  // });
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<App />);
